















































import Reflect from "reflect-metadata";
import { Component, Vue, Prop } from "vue-property-decorator";
import UserFiltersDialog from "./UserFiltersDialog.vue";
import sessionService from "@/services/SessionService";
import { SearchFilter, SearchFilters } from "@/services/SearchService";
import { User } from "@/models/User";

@Component({
  components: {
    UserFiltersDialog
  }
})
export default class UserFiltersMenu extends Vue {
  @Prop()
  filters!: SearchFilters;

  isOpen!: boolean;

  sessionUser!: User | null;

  constructor() {
    super();
    this.sessionUser = sessionService.getUser();
    this.isOpen = false;
  }

  mounted() {
    this.$root.$on("filter:apply", () => {
      this.isOpen = false;
    });

    this.$root.$on("filter:cancel", () => {
      this.isOpen = false;
    });
  }
}
